import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Typography, Space, Button, Spin, Switch, List } from "antd";
import { EditOutlined, PlusOutlined, HolderOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useCategorySort } from "../../modules/Configurations/hooks/useCategorySort";
import { useDispatch } from "react-redux";

const { Title } = Typography;

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const Panel = (props) => {
  const {
    ticketlist,
    category,
    count,
    getItemDetails,
    setVisible,
    isAction,
    setTrigger,
    getCurrentSelect,
    panelName,
    setAddSubCat,
    callApiWithShowHideData,
    switchVal = false,
    categoryRoot,
    parentKey,
    type,
    orgId,
    onUpdate,
    parentID,
    setDefaultActive,
    defaultActive,
  } = props;
  const [tickets, setTickets] = useState([]);
  const [loader, setLoader] = useState(true);
  const [color, setColor] = useState("");
  // const [defaultActive, setDefaultActive] = useState(true);

  const dispatch = useDispatch();

  const getDetails = (item, category) => {
    if (category !== "Sub-Types") {
      setColor(item.id);
      getItemDetails(item, category);
    }
  };

  useEffect(() => {
    if (ticketlist !== undefined) {
      setTickets(ticketlist);

      if (panelName === "maintenance" && defaultActive && ticketlist.length > 0) {
        setColor(ticketlist[0].id);

        let item = ticketlist[0];
        let index = 0;
        getDetails({ ...item, index }, "Maintenance Types");
        // setDefaultActive(false);
      } else if (panelName === "sub_type" && ticketlist.length > 0) {
        setColor(ticketlist[0].id);
      }

      setLoader(false);
    }
  }, [ticketlist, type, defaultActive]);

  console.log(defaultActive, "defaultActive");
  const showModal = (item) => {
    setAddSubCat(item?.type);
    setTrigger(category === "Sub-Types" ? 1 : 0);
    if (item?.type === 1) {
      getCurrentSelect({ ...item, type: category });
    }
    setVisible(true);
  };

  // You already have sorted JSON here
  const { patchSortedCategories, loading } = useCategorySort({
    orgId,
    type,
    categoryRoot,
    parentKey,
    dispatch,
    onUpdate,
    parentID,
  });

  // You already have sorted JSON here

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newOrder: any = reorder(tickets, result.source.index, result.destination.index);

    setTickets(newOrder);
    if (panelName === "maintenance" && newOrder.length > 0) {
      setColor(newOrder[0].id);
      setDefaultActive(false);
      let item = newOrder[0];
      let index = 0;
      getDetails({ ...item, index }, "Maintenance Types");
    }
    patchSortedCategories(newOrder, panelName);
  };

  const sortAlphabetically = (panelType) => {
    const sorted = [...tickets].sort((a, b) => (a?.title ?? "").localeCompare(b?.title ?? ""));
    if (panelType === "maintenance" && sorted.length > 0) {
      setColor(sorted[0].id);
      setDefaultActive(false);
      let item = sorted[0];
      let index = 0;
      getDetails({ ...item, index }, "Maintenance Types");
    }
    setTickets(sorted);
    patchSortedCategories(sorted, panelType);
  };

  const selectCategory = (item, index) => {
    getDetails({ ...item, index }, category);
    setDefaultActive(false);
  };
  return (
    <Row gutter={[24, 24]}>
      <Col span={24}>
        <Card
          loading={loading}
          bordered={false}
          className="ag-nospace-body"
          style={{ borderRadius: 4, height: 500, overflowY: "auto" }}
          title={`${category} (${count ?? 0})`}
          extra={
            <Space>
              <Button
                title="Sort A-Z"
                size="small"
                type="primary"
                className="ag-green"
                onClick={() => sortAlphabetically(panelName)}
              >
                Sort A-Z
              </Button>

              {panelName === "sub_type" && (
                <Button
                  title="Add new sub type"
                  size="large"
                  type="primary"
                  className="ag-green"
                  onClick={() => showModal({ type: 2 })}
                >
                  Add Sub-Type <PlusOutlined />
                </Button>
              )}
            </Space>
          }
        >
          <Space size={24} direction="vertical" className="w-100">
            {loader ? (
              <Row gutter={[24, 24]}>
                <Col span={24}>
                  <Space size={24} className="w-100 text-center" direction="vertical">
                    <Spin size="large" className="ag-fontSize32" />
                  </Space>
                </Col>
              </Row>
            ) : tickets.length > 0 && count > 0 ? (
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="ticket-list-droppable">
                  {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {tickets?.map((item, index) => (
                        <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                          {(prov, snapshot) => (
                            <div
                              ref={prov.innerRef}
                              {...prov.draggableProps}
                              {...prov.dragHandleProps}
                              style={{
                                ...prov.draggableProps.style,
                                background: snapshot.isDragging ? "#f9f9f9" : "transparent",
                                marginBottom: 8,
                              }}
                            >
                              <List.Item
                                className={item.id === color && category !== "Sub-Types" ? "activec" : ""}
                                actions={
                                  isAction
                                    ? [
                                        <Col>
                                          <Switch
                                            onChange={(e) => callApiWithShowHideData(e, index, item.id)}
                                            checked={switchVal === item?.id || item?.isEnabled}
                                            checkedChildren="Show"
                                            unCheckedChildren="Hide"
                                          />
                                        </Col>,
                                        <Button
                                          type="link"
                                          className="ag-green"
                                          onClick={() =>
                                            showModal({
                                              ...item,
                                              index,
                                              type: 1,
                                            })
                                          }
                                        >
                                          <EditOutlined style={{ fontSize: 22 }} />
                                        </Button>,
                                      ]
                                    : []
                                }
                              >
                                <List.Item.Meta
                                  title={
                                    <Space>
                                      <HolderOutlined />
                                      <Button
                                        type="link"
                                        className="Sentence ant-typography"
                                        onClick={() => selectCategory(item, index)}
                                      >
                                        {item?.title ?? item?.categoryId}
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        {item?.timeInMin ? item?.timeInMin + " mins" : ""}
                                      </Button>
                                    </Space>
                                  }
                                />
                              </List.Item>
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <Title level={5} className="highlight ag-primary mb-0 p-1 text-center">
                There are currently no data.
              </Title>
            )}
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default Panel;
